// @flow
import React, { useState } from "react";
import PageContainer from "../containers/PageContainer";
import ProductList from "../containers/ProductList";
import Pager from "../containers/Pager";
import { useTranslation } from 'react-i18next';
import {useParams } from 'react-router-dom';
import { utils } from "../common/utils";


export default function ProductsView(props) {
    const { t } = useTranslation();

    const isSearch = props.isSearch !== undefined && props.isSearch === true;
    const { searchTerm } = useParams();
    const title = utils.isNullOrEmpty(searchTerm) ? t("Product List") : `${t("SearchResultsFor")}: ${searchTerm}`;
  return (
      <PageContainer title={title} showShopToolbar={false}>
          <ProductList isSearch={isSearch} />
          <Pager />
    </PageContainer>
  );
}
